import { Scene } from "@babylonjs/core/scene";
import { ActionManager } from "@babylonjs/core/Actions/actionManager";
import { ExecuteCodeAction } from "@babylonjs/core/Actions/directActions";

export abstract class HoverHelper {

  private static _clickableObjects: Object[] = [];

  public static AddToHoverList(obj: any) {
    this._clickableObjects.push(obj);
  }

  public static CreateHoverManager(scene: Scene) {
    let hoverManager = new ActionManager(scene)
    let canvas = document.querySelector('#render-canvas') as HTMLCanvasElement

    hoverManager.registerAction(new ExecuteCodeAction(ActionManager.OnPointerOverTrigger, () => {
      canvas.style.cursor = 'pointer'
    }))

    hoverManager.registerAction(new ExecuteCodeAction(ActionManager.OnPointerOverTrigger, () => {
      canvas.style.cursor = 'grab'
    }))

    this._clickableObjects.forEach((obj: any) => {
      obj.actionManager = hoverManager;
    })
  }

  public static CleanupHoverList() {
    this._clickableObjects = []
  }
}